export const slickTheme = `

  /* Arrows */
  .slick-prev,
  .slick-next {
    position: absolute;
    top: 50%;
    padding: 0;
    -webkit-transform: translate(0, -50%);
    -ms-transform: translate(0, -50%);
    transform: translate(0, -50%);
    cursor: pointer;
    display: block;
    width: 48px;
    height: 48px;
    background: #8971DE;
    border-radius: 100%;
    left: 0;
  }
  .slick-next {
    right: 0;
    left: inherit;
  }
  .slick-prev {
    z-index: 999;
  }
  .slick-prev.slick-disabled:before,
  .slick-next.slick-disabled:before {
    opacity: .25;
  }

  /* Dots */
  .slick-dotted.slick-slider {
    margin-bottom: 30px;
  }

  .slick-dots {
    padding: 12px 0;
    text-align: center;
  }

  .slick-dots li {
    position: relative;
    display: inline-block;
    margin: 0 6px;
    padding: 0;
    cursor: pointer;
  }
  .slick-dots li button {
    line-height: 8px;
    display: block;
    cursor: pointer;
    color: transparent;
    border: 0;
    outline: none;
    background: transparent;
  }
  .slick-dots li button:hover,
  .slick-dots li button:focus {
    outline: none;
  }
  .slick-dots li button:hover:before,
  .slick-dots li button:focus:before {
    opacity: 1;
  }
  .slick-dots li button:before {
    position: absolute;
    top: 0;
    left: 0;
    width: 6px;
    height: 6px;
    content: '';
    border-radius: 100%;
    background: #D9CFFF;
  }
  .slick-dots li.slick-active button:before {
    background: #5A4B92;
    width: 8px;
    height: 8px;
  }
  .slick-top-section.slick-arrow {
    width: 30px;
    height: 30px;
  }
  .slick-opportunity-category.slick-arrow {
    width: 44px;
    height: 44px;
    background: #000;
  }
  .slider-product-detail-secondary
  .slick-slide.slick-active.slick-current img {
    border: 2px solid #000;
  }
  .slider-product-detail-secondary
  .slick-list {
    margin: 0;
  }
  .slider-product-detail-principal
  .slick-list {
    margin: 0;
  }
  .slider-product-detail-principal
  .slick-next div{
    border-radius: 100%;
  }
  .slider-product-detail-principal
  .slick-next{
    right: 6px;
    width: 32px;
    height: 32px;
  }
  .slider-product-detail-principal
  .slick-next.slick-disabled{
    opacity: 0;
  }
  .slider-product-detail-principal
  .slick-prev div{
    border-radius: 100%;
  }
  .slider-product-detail-principal
  .slick-prev{
    left: 6px;
    width: 32px;
    height: 32px;
  }
  .slider-product-detail-principal
  .slick-prev.slick-disabled{
    opacity: 0;
  }
`;
